// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-h_fe","catalogByServiceItem__title":"c-h_ff"};